<template lang="pug">
  nav.b-menu-top
    router-link._item(
      v-for="item in actualMenuItems"
      :key="item.label"
      :to="item.to"
      :target="item.blank ? '_blank' : '_self'"
      ) {{ item.label }}
</template>

<script>
export default {
  name: 'MenuTop',
  props: {
    items: Array,
  },
  data() {
    return {
      defaultItems: [
        { label: 'Главная',     to: { name: 'home'            } }, // eslint-disable-line
        { label: 'Проекты',     to: { name: 'project-list'    } }, // eslint-disable-line
        { label: 'Тарифы',      to: { name: 'tariffs'         } }, // eslint-disable-line
        // { label: 'События',   to: { name: 'events'        } }, // eslint-disable-line
        { label: 'Контакты',    to: { name: 'contacts'        } }, // eslint-disable-line
        { label: 'Диаграмма Ганта',     to: { name: 'gantt'         } }, // eslint-disable-line
        // { label: 'Сделка',      to: { name: 'deals'           } }, // eslint-disable-line
        { label: 'Партнерство', to: { name: 'affiliate-main'  } }, // eslint-disable-line
        { label: 'Гайды', to: { name: 'guides'                } }, // eslint-disable-line
      ],
    };
  },
  computed: {
    isPaidTariff() { return this.$store.state.auth.user?.tariff?.pricePerDay > 0; },
    actualMenuItems() { return this.items ?? this.defaultItems.filter(i => this.isPaidTariff || i.label !== 'Партнерство'); },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/styles/helpers/functions";
$menuHeight: 48px;

.menu-top {
  display: flex;
  margin-top: - $menuHeight/2;
  border-radius: 6px;
  color: #99a3c5;
  background-color: var(--color-white);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);

  &__item {
    height: $menuHeight;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    position: relative;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    transition: color 0.2s;

    &:hover {
      color: var(--color-dark-gray);
      &:after {
        height: 3px;
      }
    }
    &:after {
      content: "";
      display: inline-block;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 0;
      transition: height 0.3s;
      background-color: #588cf4;
    }

    &.router-link-exact-active, &.router-link-active:not([href="/"]) {
      color: var(--color-dark-gray);
      &:after {
        height: 3px;
      }
    }
  }

  @media (max-width: 768px) {
    width: calc(100% + 25px);
    border-radius: 6px 0 0 6px;
    overflow: auto;

    &__item {
      padding: 0 30px;
    }
  }

  @media (max-width: 576px) {
    width: calc(100% + 15px);
  }
}
</style>
